import { Box, Typography } from "@material-ui/core";
import PropTypes from "prop-types";
import SvgIcon from "@material-ui/core/SvgIcon";
import travaCoinBlack from "src/assets/images/logo/logo_only_black.png";
import travaCoinBlue from "src/assets/images/logo/logo_only_blue.png";
import travaCoinWhite from "src/assets/images/logo/logo_only_white.png";

export const DiamondDivider = (props) => (
  <Box {...props}>
    <svg fill="none" stroke="#c4c4c4" viewBox="0 0 953.42 55.97">
      <rect x="480.63" y="16.31" width="38.57" height="38.57" transform="translate(148.38 -350.69) rotate(45)" />
      <rect
        strokeWidth={2}
        x="488.1"
        y="23.77"
        width="23.65"
        height="23.65"
        transform="translate(148.38 -350.69) rotate(45)"
      />
      <rect
        fill="#c4c4c4"
        x="528.53"
        y="30.8"
        width="9.6"
        height="9.6"
        transform="translate(158.17 -374.31) rotate(45)"
      />
      <rect
        fill="#c4c4c4"
        x="461.72"
        y="30.8"
        width="9.6"
        height="9.6"
        transform="translate(138.6 -327.07) rotate(45)"
      />
      <polygon fill="#c4c4c4" points="438.19 29.23 0 28 438.19 26.78 438.19 29.23" />
      <polygon fill="#c4c4c4" points="515.23 26.78 953.42 28 515.23 29.23 515.23 26.78" />
    </svg>
  </Box>
);

DiamondDivider.defaultProps = {
  width: "80%",
  margin: "auto",
};

export function Empty({ size, color, title, titleFontSize }) {
  return (
    <>
      <svg width={size} height={size} fill={color} viewBox="0 0 193.24 131.23">
        <path
          d="M17.7,134.46c0-6.7,0-13.4,0-20.1,0-1-.35-1.38-1.31-1.56-3.69-.68-7.36-1.44-11-2.16-2-.41-2.42-1.1-1.59-3q6.89-15.81,13.75-31.61a2.62,2.62,0,0,1,2.15-1.65c7.07-1.37,14.12-2.79,21.18-4.17.68-.14.84-.45.77-1.13a23.94,23.94,0,0,1,7.75-20.48A24,24,0,0,1,68.7,41.8c11,1.05,18.55,6.9,22.34,17.36.29.8.59.92,1.33.75,2-.44,4-.71,6-1.26s3.76.16,5.58.53q26.64,5.28,53.27,10.63l23.33,4.67A2.35,2.35,0,0,1,182.43,76q6.9,15.93,13.84,31.82c.73,1.67.35,2.42-1.47,2.79-3.68.74-7.35,1.49-11,2.17-1.09.19-1.5.56-1.49,1.75,0,13.33,0,26.65,0,40,0,1.85-.21,2.09-2,2.45L125.19,168c-8.15,1.64-16.3,3.32-24.48,4.84a11.29,11.29,0,0,1-4-.46q-24.63-4.92-49.27-9.88l-28.11-5.62c-1.3-.26-1.64-.69-1.64-2.09Zm84,35.06c.39-.05.69-.09,1-.15l30.83-6.16q22.25-4.46,44.49-8.89c.89-.17,1.27-.43,1.27-1.46,0-12.47,0-24.94,0-37.41v-1.69c-2.57.5-4.92.94-7.26,1.41l-56.65,11.34c-1.62.32-2,.12-2.67-1.43l-10.29-23.61c-.16-.36-.34-.71-.51-1.06l-.15.08ZM20.92,113.76a4.18,4.18,0,0,0-.12.67q0,19.41,0,38.81c0,.63.22.87.84,1,1.79.32,3.56.72,5.34,1.07l64.64,12.94,6.75,1.33V100.48a3.12,3.12,0,0,0-.69,1.06q-5.17,11.85-10.34,23.72c-.44,1-1,1.59-2.22,1.35Q57.24,121,29.36,115.43Zm171.86-5.9a4.55,4.55,0,0,0-.09-.49Q186.41,93,180.13,78.54c-.25-.59-.57-.65-1.16-.53q-18.54,3.73-37.09,7.43l-33.11,6.63-6.51,1.32c.12.32.17.5.24.66q6.21,14.27,12.4,28.52c.32.73.74.75,1.36.62q3.63-.75,7.28-1.47l56.31-11.27ZM7.14,107.77c.44.13.77.24,1.11.31q18.77,3.75,37.54,7.5t37.76,7.58a1.21,1.21,0,0,0,1.65-.84c4-9.3,8.09-18.58,12.14-27.87.13-.31.23-.63.35-1a1.22,1.22,0,0,0-.36-.2q-9.87-2-19.77-4a1.26,1.26,0,0,0-.65.12,26.75,26.75,0,0,1-9.11,2,25.33,25.33,0,0,1-18.87-7.15,4.06,4.06,0,0,0-1.77-.94c-6.44-1.33-12.88-2.61-19.33-3.9l-7.65-1.5ZM67.59,44.58a24.17,24.17,0,0,0-9.36,1.67A21.93,21.93,0,0,0,46.34,75.49a22.68,22.68,0,0,0,34.79,8,21.74,21.74,0,0,0,7.18-23.37A22.22,22.22,0,0,0,67.59,44.58Zm104.7,31.65,0-.25L101.66,61.83V90.37ZM92,63.11a25.32,25.32,0,0,1-1.83,13.32A26,26,0,0,1,81.38,87l16.94,3.39V61.86Zm-49.79,10L27.69,76l0,.25L45.09,79.7C44.09,77.42,43.16,75.31,42.17,73.08Z"
          transform="translate(-3.38 -41.68)"
        />
        <path
          d="M61.27,58.86c0-3.37,0-6.74,0-10.11,0-1.69.44-2.12,2.15-2.12,2.32,0,4.64,0,7,0,1.57,0,2.08.52,2.08,2.1q0,10.17,0,20.33c0,1.55-.48,2-2,2q-3.64,0-7.31,0c-1.41,0-1.87-.48-1.88-1.91C61.26,65.75,61.27,62.3,61.27,58.86Zm8.11-9.37c-1.42,0-2.73,0-4,0-.92,0-1.22.27-1.21,1.19,0,2.9,0,5.8,0,8.7q0,3.89,0,7.77c0,.48-.14,1.08.66,1.08h4.55Z"
          transform="translate(-3.38 -41.68)"
        />
        <path
          d="M61.47,79.43A5.2,5.2,0,0,1,66.9,74.2a5.27,5.27,0,0,1,5.35,5.23,5.44,5.44,0,0,1-5.41,5.37A5.36,5.36,0,0,1,61.47,79.43ZM66.88,77a2.57,2.57,0,0,0-2.51,2.52,2.51,2.51,0,0,0,2.46,2.42,2.59,2.59,0,0,0,2.54-2.49A2.73,2.73,0,0,0,66.88,77Z"
          transform="translate(-3.38 -41.68)"
        />
      </svg>
      <Typography component="p" variant="h5" style={{ color, fontSize: titleFontSize }}>
        {title}
      </Typography>
    </>
  );
}

Empty.propTypes = {
  color: PropTypes.string.isRequired,
  title: PropTypes.node.isRequired,
  titleFontSize: PropTypes.string.isRequired,
};

Empty.defaultProps = {
  size: "5rem",
  color: "#2c85ee99",
  title: "Empty",
  titleFontSize: "1.3rem",
};

export function Chest(props) {
  const { fill, ...rest } = props;

  return (
    <svg {...rest} viewBox="0 0 24 20" fill="none">
      <path
        d="M14.0234 19.2101C11.1645 19.1202 8.39016 19.0329 5.56873 18.9439C5.07914 15.3231 4.5913 11.7197 4.09998 8.08752C4.99187 8.08752 5.8445 8.08752 6.78701 8.08752C6.78701 9.17752 6.78701 10.2588 6.78701 11.4116C8.25576 11.4116 9.6355 11.4116 11.0842 11.4116C11.0842 10.3513 11.0842 9.2805 11.0842 8.18439C11.97 8.18439 12.7894 8.18439 13.6403 8.18439C13.7677 11.8619 13.8951 15.5159 14.0234 19.2101Z"
        fill={fill}
      />
      <path
        d="M13.6517 7.37798C12.786 7.37798 11.9779 7.37798 11.148 7.37798C11.1366 7.16591 11.1279 6.99486 11.1157 6.75662C9.67572 6.75662 8.23489 6.75662 6.77313 6.75662C6.76614 6.90323 6.75829 7.07428 6.74782 7.28111C5.86901 7.28111 4.99457 7.28111 4.073 7.28111C4.28768 5.07406 4.57218 2.92896 5.71629 1.00728C6.10988 0.346651 6.61517 -0.0224998 7.48001 0.00106308C10.0501 0.0708789 12.6237 0.0394618 15.1955 0.0481888C15.3936 0.0490615 15.5926 0.0481888 15.8553 0.0481888C14.301 2.29277 13.9144 4.81923 13.6517 7.37798Z"
        fill={fill}
      />
      <path
        d="M18.1704 19.1908C18.3135 15.4932 18.4549 11.8549 18.5972 8.17645C20.3513 7.81428 22.1045 7.45124 23.9328 7.07336C23.8735 7.44862 23.8185 7.76803 23.7714 8.08831C23.4843 10.0554 23.1989 12.0224 22.9126 13.9895C22.7355 15.2095 22.561 16.4296 22.3724 17.647C22.3559 17.7526 22.2616 17.9018 22.1709 17.9315C20.8653 18.353 19.5545 18.7579 18.1704 19.1908Z"
        fill={fill}
      />
      <path
        d="M14.889 19.2684C14.7694 15.5568 14.6534 11.9317 14.5347 8.26196C15.6404 8.26196 16.7042 8.26196 17.8169 8.26196C17.6807 11.9378 17.5446 15.6014 17.4085 19.2684C16.5715 19.2684 15.7538 19.2684 14.889 19.2684Z"
        fill={fill}
      />
      <path
        d="M0.128409 8.04209C1.10409 8.04209 2.03176 8.03161 2.95944 8.05605C3.06504 8.05867 3.24045 8.24368 3.2579 8.36237C3.50575 10.072 3.73265 11.7851 3.96392 13.4973C4.19518 15.2087 4.42557 16.92 4.65509 18.6323C4.66469 18.703 4.66207 18.7754 4.66469 18.826C3.90457 18.826 3.15318 18.8374 2.40266 18.8103C2.31539 18.8068 2.18536 18.6043 2.16005 18.4769C1.8005 16.7158 1.45404 14.9521 1.1067 13.1884C0.778569 11.5259 0.453925 9.86253 0.129282 8.19917C0.118809 8.14419 0.128409 8.08485 0.128409 8.04209Z"
        fill={fill}
      />
      <path
        d="M24 6.28267C22.1883 6.65706 20.4472 7.01661 18.6172 7.39362C18.6844 6.78622 18.7341 6.21897 18.8127 5.6552C18.9977 4.31736 19.2665 2.99784 19.8547 1.77082C20.0528 1.35717 20.2989 0.949615 20.5956 0.602282C21.1087 0.00273811 21.6804 0.00884697 22.2459 0.557774C22.3698 0.678206 22.4832 0.814347 22.5784 0.959215C23.6361 2.56934 23.9057 4.38455 24 6.28267Z"
        fill={fill}
      />
      <path
        d="M17.8441 7.43647C16.7271 7.43647 15.6563 7.43647 14.4965 7.43647C14.6291 6.53061 14.7312 5.65791 14.89 4.79568C15.1213 3.53638 15.4913 2.31897 16.1476 1.2054C16.2357 1.05617 16.3396 0.915668 16.4365 0.7708C16.7541 0.292562 17.1451 0.0307524 17.7734 0.0900959C18.4751 0.156421 19.1872 0.104932 19.9665 0.104932C18.3852 2.34166 18.1147 4.87946 17.8441 7.43647Z"
        fill={fill}
      />
      <path
        d="M3.19408 7.22869C2.12589 7.22869 1.08651 7.22869 0 7.22869C0.0706885 5.02862 0.315917 2.93152 1.53769 1.08053C1.93914 0.471386 2.48021 0.0830359 3.26825 0.0961263C3.92714 0.106599 4.5869 0.0446371 5.3252 0.0114746C3.79711 2.24995 3.45676 4.7415 3.19408 7.22869Z"
        fill={fill}
      />
      <path
        d="M7.26782 10.9683C7.26782 9.64002 7.26782 8.40865 7.26782 7.17029C8.36655 7.17029 9.49495 7.17029 10.626 7.17029C10.626 8.46275 10.626 9.71507 10.626 10.9683C9.49146 10.9683 8.42677 10.9683 7.26782 10.9683ZM8.33164 10.2762C8.73483 10.2762 9.09787 10.2762 9.51327 10.2762C9.44433 9.96554 9.35619 9.70198 9.33612 9.43407C9.32215 9.25342 9.36142 9.04223 9.44869 8.88427C9.63545 8.54653 9.64592 8.24371 9.35881 7.97841C9.10223 7.74103 8.80552 7.74016 8.52276 7.93913C8.2435 8.13636 8.13616 8.557 8.37179 8.8258C8.59432 9.07975 8.54807 9.31974 8.50793 9.57981C8.47476 9.79362 8.4032 10.0004 8.33164 10.2762Z"
        fill={fill}
      />
    </svg>
  );
}

Chest.propTypes = {
  stroke: PropTypes.string.isRequired,
  fill: PropTypes.string.isRequired,
  strokeWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

Chest.defaultProps = {
  stroke: "currentColor",
  strokeWidth: 0,
  fill: "#C7C7C7",
  width: 24,
  height: 20,
};

export function ExternalLink(props) {
  const { size, ...rest } = props;

  return (
    <svg {...rest} viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round" height={size} width={size}>
      <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
      <polyline points="15 3 21 3 21 9" />
      <line x1="10" y1="14" x2="21" y2="3" />
    </svg>
  );
}

ExternalLink.propTypes = {
  stroke: PropTypes.string.isRequired,
  fill: PropTypes.string.isRequired,
  strokeWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

ExternalLink.defaultProps = {
  stroke: "currentColor",
  strokeWidth: 2,
  fill: "none",
  size: "1rem",
};

export function Wallet(props) {
  const { size, fill, ...rest } = props;

  return (
    <svg {...rest} width={size} height={size} fill={fill} viewBox="0 0 29.51 27.96">
      <path
        d="M28,15.24l.5.1a1.82,1.82,0,0,1,1.27,1.74c0,1.44,0,2.89,0,4.34A1.86,1.86,0,0,1,28,23.36v.19c0,.6,0,1.2,0,1.8a3.81,3.81,0,0,1-1.49,2.73,4,4,0,0,1-2.62.9H4.33a4.06,4.06,0,0,1-4.08-4.1v-15A3.74,3.74,0,0,1,3.88,6.18c1.15,0,2.3,0,3.46,0,.14,0,.19,0,.24-.18A6.89,6.89,0,0,1,13,1.16a7,7,0,0,1,7.29,3.18A6.52,6.52,0,0,1,21,6a.19.19,0,0,0,.22.16H23A2.76,2.76,0,0,1,25.85,9c0,.35,0,.7,0,1.05a.23.23,0,0,0,.13.23,3.9,3.9,0,0,1,1.95,2.92A15.63,15.63,0,0,1,28,14.91ZM2.29,9.43h0a6.88,6.88,0,0,0-.1.9c0,4.87,0,9.73,0,14.6a2,2,0,0,0,.27,1,2.1,2.1,0,0,0,1.9,1.11H23.94a2.14,2.14,0,0,0,2.11-1.9c.05-.58,0-1.18,0-1.77,0,0,0,0,0-.05H23.34A4,4,0,0,1,23,15.28c.91,0,1.82,0,2.73,0h.3a.81.81,0,0,0,0-.09c0-.49,0-1,0-1.46a2.13,2.13,0,0,0-2.19-2.06H12.75c-2.36,0-4.72,0-7.07,0a3.61,3.61,0,0,1-2.83-1.39C2.64,10,2.48,9.7,2.29,9.43Zm13.9.3h2.89a.18.18,0,0,0,.13-.11,8.71,8.71,0,0,0,.22-1.11,4.94,4.94,0,0,0-2-4.51,4.88,4.88,0,0,0-5.52-.47A5,5,0,0,0,9.17,7.77a4.83,4.83,0,0,0,.27,2h3c0-.4.18-.52.58-.53h.41a.45.45,0,0,1,.45.42s.05.12.08.12h.84a3.52,3.52,0,0,1,0-.46.52.52,0,0,0-.36-.58c-.4-.18-.81-.35-1.2-.56A1.4,1.4,0,0,1,12.44,7c0-.16,0-.33,0-.49a1.33,1.33,0,0,1,.94-1.38.29.29,0,0,0,.23-.35A.41.41,0,0,1,14,4.32a5.61,5.61,0,0,1,.58,0,.43.43,0,0,1,.42.44V5a1.46,1.46,0,0,1,1.14,1.59c0,.2-.08.3-.28.31S15.31,7,15,7a.28.28,0,0,1-.29-.31V6.5c0-.25-.16-.36-.46-.35s-.42.12-.43.37a1.71,1.71,0,0,0,0,.32.94.94,0,0,0,.15.32,1,1,0,0,0,.29.18c.39.18.79.33,1.16.53a1.3,1.3,0,0,1,.74,1.24Zm11.65,7.44-.11,0c-1.47,0-2.94,0-4.41,0a2.15,2.15,0,1,0,0,4.29c1.46,0,2.92,0,4.39,0h.14ZM7.23,8.09H3.91a.22.22,0,0,0,0,.09A1.86,1.86,0,0,0,5.6,9.73c.61,0,1.23,0,1.83,0Zm14,1.65h2.76a7.33,7.33,0,0,0,0-.94.83.83,0,0,0-.82-.72H21.39Z"
        transform="translate(-0.25 -1.02)"
      />
      <path d="M22.28,19.32a1.07,1.07,0,0,1,2.14,0,1.07,1.07,0,0,1-2.14,0Z" transform="translate(-0.25 -1.02)" />
    </svg>
  );
}

Wallet.propTypes = {
  stroke: PropTypes.string.isRequired,
  fill: PropTypes.string.isRequired,
  strokeWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

Wallet.defaultProps = {
  stroke: "currentColor",
  strokeWidth: 0,
  fill: "white",
  size: "1rem",
};

export function CollectionIcon(props) {
  const { fill, ...rest } = props;

  return (
    <svg {...rest} viewBox="0 0 30 31" fill="none">
      <path
        d="M20.8968 10.674V12.3105H20.7775V17.8986C20.7775 18.5055 20.4911 19.0783 20.007 19.4431L18.0363 20.933V17.2474L18.7864 16.4019C18.8682 16.3098 18.9398 16.2109 19.0046 16.1087C19.0659 16.003 19.1205 15.8939 19.1648 15.7813C19.2262 15.6109 19.2705 15.4336 19.2876 15.2495C19.291 15.1881 19.2944 15.1267 19.2944 15.0654V13.48H17.068C16.5429 13.48 16.1134 13.9096 16.1134 14.4346V15.0756L16.6486 15.5154V15.7507L15.3905 17.2917L14.129 15.7507V15.5154L14.6643 15.0756V14.4346C14.6643 13.9096 14.2382 13.48 13.7097 13.48H11.4833V15.0654C11.4833 15.5597 11.664 16.0336 11.9913 16.4019L12.7448 17.2474V20.933L10.7741 19.4431C10.2866 19.0783 10.0036 18.5055 10.0036 17.8986V12.3105H9.88086V10.674H10.1673C10.1741 10.6399 10.1843 10.6058 10.1945 10.5717C10.2013 10.5308 10.2116 10.4899 10.2218 10.4558C10.7332 8.56693 12.1175 6.99517 14.0029 6.26554C14.1154 6.22122 14.2313 6.18371 14.3473 6.14962C14.4189 6.12916 14.4939 6.11211 14.5655 6.09848V5.93823H16.2156V6.09848C16.219 6.09848 16.2225 6.09848 16.2225 6.09848C16.277 6.10871 16.3316 6.12234 16.3861 6.13939C16.3998 6.1428 16.4168 6.14621 16.4304 6.14962C16.5464 6.1803 16.6623 6.22122 16.7782 6.26554C18.6636 6.99517 20.0479 8.56693 20.5593 10.4558C20.5695 10.4899 20.5798 10.5308 20.5866 10.5717C20.5968 10.6058 20.607 10.6399 20.6138 10.674H20.8968Z"
        fill={fill}
      />
      <path
        d="M29.8225 7.65999C29.8225 7.64977 29.8259 7.64295 29.8259 7.63272L29.802 7.64977C26.113 5.88367 23.0479 3.7698 21.575 0.145541C21.5852 0.128494 21.5954 0.114856 21.6057 0.0978089C21.5954 0.101218 21.5784 0.101218 21.5545 0.101218C21.1761 0.111447 19.3384 -0.0385695 18.4144 0.114856C18.4144 0.114856 18.7519 0.541039 18.8985 0.718331C18.8781 0.718331 18.861 0.72174 18.844 0.72515C18.2678 0.40807 17.3916 0.00575347 17.3916 0.00575347C17.3916 0.00575347 15.6118 -0.00447492 14.722 0.002344C12.9218 0.0159818 11.1216 0.0603048 9.32137 0.135313C7.85189 3.80048 4.70836 5.89048 0.985232 7.66681L0.9375 7.64295L0.981823 7.67022V8.55327C2.64905 17.9566 5.69029 26.5041 15.5334 30.8307C25.3731 26.5041 28.1586 17.9191 29.8259 8.51577L29.8429 7.67022C29.8361 7.66681 29.8293 7.6634 29.8225 7.65999ZM15.5334 26.3677C9.14748 23.173 5.50618 17.7111 3.85941 9.93411C6.51879 8.38621 8.6838 6.4019 10.6647 4.12097C13.7537 3.96755 16.9245 3.90959 19.9759 3.99482C19.9793 3.988 19.9828 3.98459 19.9862 3.97778C21.8955 6.29621 24.2991 8.65215 26.9653 10.0466C25.3322 17.7043 21.7693 23.1662 15.5334 26.3677Z"
        fill={fill}
      />
    </svg>
  );
}

CollectionIcon.propTypes = {
  stroke: PropTypes.string.isRequired,
  fill: PropTypes.string.isRequired,
  strokeWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

CollectionIcon.defaultProps = {
  stroke: "currentColor",
  strokeWidth: 0,
  fill: "#C7C7C7",
  width: 24,
  height: 26,
};

export function EquipmentIcon(props) {
  const { fill, ...rest } = props;
  return (
    <svg {...rest} viewBox="0 0 46 38" fill="none">
      <path
        d="M30.4872 11.7216L27.913 9.0901L27.3287 9.09297L26.3424 10.0822L25.6525 10.7877C25.274 11.1805 25.0669 11.407 25.0798 11.4202L25.0818 11.4183L25.0798 11.4202L25.0816 11.4221C25.0582 11.4706 26.0699 12.5709 27.5601 14.1244L26.4434 15.0558L26.471 15.0843L13.5376 25.5842C13.5376 25.5842 12.8257 31.7178 12.7134 32.6922C13.6873 32.6026 19.8385 32.032 19.8385 32.032L31.0371 18.8824L31.6035 18.2634C33.1349 19.799 34.2204 20.8461 34.2696 20.8242L34.2715 20.8261L34.6449 20.4604L35.8116 19.3221L36.516 18.6356L36.6353 18.0117L34.0501 15.3689L34.3103 15.0761L34.2993 15.0647L38.0081 10.7146L38.1935 10.4981L38.2505 10.4317C39.1984 10.5294 40.2042 10.2064 40.9672 9.46314C42.2834 8.17628 42.3696 6.13334 41.1579 4.89546C39.9481 3.65948 37.8989 3.69752 36.5848 4.98242C35.8499 5.7021 35.4974 6.65881 35.5438 7.5788L35.3556 7.73182L30.4872 11.7216Z"
        fill={fill}
      />
      <path
        d="M11.6661 15.2623L9.07505 17.8772L9.08702 18.4614L10.0915 19.4322L10.8077 20.111C11.2063 20.4834 11.4359 20.6869 11.449 20.6738L11.447 20.6719L11.449 20.6738L11.4509 20.672C11.4998 20.6947 12.5841 19.6659 14.1142 18.1518L15.0629 19.2538L15.091 19.2257L25.791 31.994C25.791 31.994 31.935 32.6104 32.911 32.7074C32.8063 31.7351 32.1399 25.5935 32.1399 25.5935L18.8175 14.601L18.1898 14.0444C19.7013 12.4892 20.7314 11.3875 20.7087 11.3387L20.7106 11.3368L20.3391 10.9691L19.1828 9.82024L18.4854 9.12661L17.8598 9.01704L15.2575 11.6432L14.9607 11.3875L14.9495 11.3987L10.5421 7.75808L10.3227 7.57607L10.2555 7.52008C10.3384 6.57078 9.99974 5.57012 9.24474 4.81886C7.93754 3.52288 5.8935 3.46848 4.67464 4.69926C3.45765 5.92817 3.5276 7.97653 4.83281 9.27052C5.56385 9.99408 6.52593 10.3316 7.44509 10.2709L7.60102 10.4568L11.6661 15.2623Z"
        fill={fill}
      />
      <path
        d="M35.1055 13.7067C35.0385 17.415 34.2875 20.8619 32.6587 24.0964C30.8802 27.6282 28.2925 30.4333 24.9918 32.5823C24.257 33.0606 23.4814 33.4761 22.7205 33.913C22.6611 33.9472 22.5522 33.9491 22.4916 33.9174C20.1067 32.6772 17.9495 31.1278 16.1009 29.1645C13.4216 26.3189 11.6657 22.9756 10.7634 19.1772C10.1875 16.7535 9.98664 14.2972 10.1728 11.8128C10.2104 11.3127 10.2932 10.8159 10.3701 10.3198C10.3804 10.2519 10.4671 10.1634 10.536 10.1424C12.5526 9.51887 14.5715 8.90293 16.5901 8.28579C18.5389 7.68969 20.4877 7.09279 22.4377 6.50105C22.5316 6.47248 22.6484 6.46454 22.7407 6.49232C26.7029 7.7 30.6636 8.91324 34.6258 10.1213C34.7632 10.1634 34.8238 10.2201 34.8508 10.3682C35.0571 11.5056 35.1031 12.6538 35.1055 13.7067ZM33.6965 13.4523C33.668 13.0288 33.6149 12.2839 33.5698 11.5386C33.5587 11.3564 33.4838 11.2715 33.3032 11.2163C29.8001 10.1515 26.2997 9.07755 22.7966 8.01155C22.6797 7.97583 22.5336 7.97305 22.4175 8.00837C18.8958 9.07993 15.3764 10.1586 11.8554 11.2326C11.7267 11.2719 11.6507 11.3203 11.6451 11.4679C11.6376 11.6592 11.6039 11.8489 11.5885 12.0402C11.4292 14.0099 11.5473 15.9657 11.9081 17.9064C12.4345 20.7373 13.4664 23.365 15.0904 25.749C16.8951 28.3981 19.2483 30.4408 21.9968 32.0596C22.45 32.3263 22.7657 32.3192 23.2145 32.0553C26.1733 30.315 28.664 28.0858 30.4976 25.1612C32.6793 21.683 33.6383 17.8564 33.6965 13.4523Z"
        fill={fill}
      />
    </svg>
  );
}

EquipmentIcon.propTypes = {
  stroke: PropTypes.string.isRequired,
  fill: PropTypes.string.isRequired,
  strokeWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

EquipmentIcon.defaultProps = {
  stroke: "currentColor",
  strokeWidth: 0,
  fill: "#C7C7C7",
  width: 35,
  height: 40,
};

export function KnightUnit(props) {
  const { fill, ...rest } = props;

  return (
    <svg {...rest} viewBox="0 0 23 25" fill="none">
      <g clipPath="url(#clip0_320:13)">
        <path
          d="M9.57849 11.2399C14.1197 11.2399 18.5186 11.2399 22.986 11.2399C22.986 11.9862 23.0191 12.7129 22.9797 13.436C22.8449 15.9183 22.6122 18.3873 21.5859 20.7106C20.6525 22.8235 19.1608 24.3687 16.7763 24.9548C16.4889 25.0257 16.1405 25.0123 15.8569 24.9254C13.7433 24.2819 12.375 22.8394 11.425 20.9822C10.4026 18.9831 9.97653 16.8323 9.77179 14.6362C9.66878 13.5265 9.64208 12.4095 9.57849 11.2399Z"
          fill={fill}
        />
        <path
          d="M4.60483 0.429443C6.11307 6.29956 5.96174 12.1501 5.95411 18.09C6.52637 18.0166 7.04014 17.9676 7.54755 17.882C8.04351 17.7976 8.53312 17.6752 9.07614 17.559C9.07614 18.041 9.07614 18.4949 9.07614 19.0418C8.10583 19.0418 7.11899 19.0418 6.13215 19.0418C5.17201 19.0418 5.09698 19.0406 5.08681 20.0157C5.07155 21.474 5.17201 22.9324 5.22415 24.3907C5.2267 24.4666 5.24323 24.5424 5.25722 24.6526C4.77143 24.6526 4.31361 24.6526 3.81892 24.6526C3.90031 23.9344 4.03893 23.2382 4.04274 22.5409C4.0491 21.5291 3.96008 20.5173 3.90794 19.5055C3.89014 19.158 3.71464 19.0247 3.33567 19.0332C2.2382 19.0553 1.13944 19.0418 0 19.0418C0 18.539 0 18.0802 0 17.6214C0.988112 17.8049 1.97241 17.9872 3.04954 18.1866C3.12966 12.2357 3.11567 6.34972 4.60483 0.429443Z"
          fill={fill}
        />
        <path
          d="M14.6768 3.40367C12.8353 4.36407 11.0333 4.39955 9.23388 3.42079C9.08382 5.24863 8.78879 5.24374 11.1198 5.90807C11.1198 7.25754 11.1198 8.60578 11.1198 9.98216C9.95748 9.817 8.96174 9.35209 8.06264 8.69142C7.95201 8.61067 7.89096 8.32683 7.94819 8.19592C8.68196 6.53448 8.68069 4.88771 7.95582 3.22137C7.87443 3.03418 7.952 2.69529 8.08681 2.52033C8.95411 1.40699 10.0516 0.559141 11.4161 0.0709844C11.6476 -0.0122103 11.963 -0.0268917 12.1893 0.0538561C13.5437 0.539566 14.7047 1.30912 15.5682 2.43224C15.7361 2.65124 15.834 3.05009 15.7501 3.29845C15.2071 4.90362 15.1702 6.49533 15.773 8.08214C15.9129 8.44918 15.8251 8.66206 15.497 8.82478C14.6475 9.24442 13.7968 9.65917 12.8633 10.1167C12.8633 8.58253 12.8633 7.24653 12.8633 5.85546C12.8926 5.84812 12.9689 5.83099 13.0439 5.81142C14.7404 5.35385 14.8332 5.22416 14.6768 3.40367Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_320:13">
          <rect width="23" height="25" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

KnightUnit.propTypes = {
  stroke: PropTypes.string.isRequired,
  fill: PropTypes.string.isRequired,
  strokeWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

KnightUnit.defaultProps = {
  stroke: "currentColor",
  strokeWidth: 0,
  fill: "#C7C7C7",
  width: 23,
  height: 25,
};

export function TicketIcon(props) {
  const { fill, ...rest } = props;
  return (
    <svg {...rest} viewBox="0 0 33 24" fill="none">
      <path
        d="M30.9775 15.1565C31.5983 15.3634 32.0624 15.6707 32.1 16.3919V21.8474C32.0561 22.3679 31.7802 22.7128 31.3099 22.926C31.0967 23.02 30.8835 23.0075 30.664 23.0075C23.9355 23.0075 17.2132 23.0075 10.491 23.0075C7.44966 23.0075 4.41461 23.0075 1.3733 23.0075C1.16636 23.0075 0.959426 23.0012 0.758762 22.9134C0.300996 22.7002 0.0438953 22.3491 0 21.8474V16.3919C0.0376245 15.6707 0.49539 15.3384 1.12247 15.1628C1.16009 15.1502 1.20399 15.1377 1.24161 15.1252C3.06013 14.5044 4.16378 12.5541 3.71856 10.6855C3.37994 9.26827 2.51457 8.30258 1.12247 7.85108C0.501661 7.65042 0.0376245 7.33688 0 6.61574V1.16018C0.0438953 0.639711 0.319809 0.294819 0.790115 0.0816116C0.99078 -0.0061779 1.19771 9.34601e-05 1.40465 9.34601e-05C11.1431 9.34601e-05 20.8816 9.34601e-05 30.6201 9.34601e-05C31.5168 9.34601e-05 31.8931 0.294819 32.0937 1.16018V6.61574C32.0561 7.31807 31.6172 7.65669 31.0026 7.83854C30.9148 7.86362 30.827 7.90125 30.7393 7.9326C29.228 8.52205 28.2247 10.0019 28.2811 11.5571C28.3376 13.2627 29.3409 14.6172 30.9775 15.1565ZM28.9333 5.6375C29.2782 5.45565 29.4287 5.25499 29.4099 4.85993C29.3785 4.32064 29.3973 3.77509 29.4036 3.22953C29.4099 2.92854 29.297 2.79058 28.9834 2.79058C27.0395 2.79685 25.0956 2.79685 23.1516 2.79058C22.8506 2.79058 22.744 2.92227 22.744 3.21072C22.7503 4.21404 22.744 5.21736 22.744 6.22068C22.744 6.46524 22.7252 6.70353 22.6437 6.92928C22.4117 7.56263 21.8348 7.89498 21.1513 7.79464C20.5681 7.70685 20.079 7.15503 20.0664 6.51541C20.0476 5.51209 20.0602 4.50877 20.0602 3.50545C20.0602 2.79058 20.0602 2.79058 19.3578 2.79058H3.49908C3.36113 2.79058 3.22944 2.79685 3.09148 2.79058C2.81557 2.77804 2.69015 2.90345 2.69643 3.18564C2.7027 3.7939 2.7027 4.39589 2.69643 5.00416C2.69015 5.28007 2.80303 5.43684 3.04759 5.56853C5.0605 6.63455 6.2833 8.30258 6.60311 10.5475C7.02952 13.5637 5.50572 16.1598 3.11657 17.4077C2.81557 17.5645 2.68388 17.7526 2.69643 18.0912C2.71524 18.6368 2.7027 19.1761 2.7027 19.7216C2.7027 20.1731 2.75286 20.217 3.21063 20.2233C5.93841 20.2233 8.66619 20.2233 11.394 20.2233C14.0904 20.2233 16.7868 20.2233 19.4832 20.2233C20.0476 20.2233 20.0727 20.2045 20.0727 19.6464C20.0727 18.5992 20.0664 17.5582 20.079 16.511C20.0852 15.9278 20.3862 15.5077 20.9192 15.3007C21.4272 15.1001 21.91 15.1879 22.3176 15.5578C22.6562 15.8651 22.7628 16.279 22.7628 16.7242C22.7628 17.715 22.7628 18.7058 22.7628 19.7028C22.7628 20.1794 22.8067 20.2233 23.2833 20.2233C25.152 20.2233 27.0207 20.2233 28.8956 20.2233C29.3722 20.2233 29.4161 20.1794 29.4161 19.7028C29.4161 19.1384 29.4099 18.5741 29.4224 18.0097C29.4287 17.7338 29.3095 17.577 29.0712 17.4453C27.0332 16.3668 25.8167 14.6799 25.5094 12.4036C25.0956 9.46894 26.5692 6.89793 28.9333 5.6375Z"
        fill={fill}
      />
    </svg>
  );
}

TicketIcon.propTypes = {
  stroke: PropTypes.string.isRequired,
  fill: PropTypes.string.isRequired,
  strokeWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

TicketIcon.defaultProps = {
  stroke: "currentColor",
  strokeWidth: 0,
  fill: "#C7C7C7",
  width: 26,
  height: 28,
};

export function TravaCoin({ color, ...props }) {
  let imgSrc;

  if (color === "black") imgSrc = travaCoinBlack;
  else if (color === "white") imgSrc = travaCoinWhite;
  else imgSrc = travaCoinBlue;

  return <img {...props} src={imgSrc} />;
}

TravaCoin.propTypes = {
  color: PropTypes.oneOf(["blue", "white", "black"]),
};

TravaCoin.defaultProps = {
  width: 20,
  height: "auto",
  alt: "",
  color: "blue",
};

export const BeautifulBackIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 30 31">
    <circle cx="14" cy="14" r="14" transform="matrix(-1 0 0 1 29 2.4021)" fill="#1841B5" stroke="#1841B5" />
    <circle
      cx="14"
      cy="14"
      r="14"
      transform="matrix(-1 0 0 1 29 1)"
      fill="url(#paint0_linear_106_442)"
      stroke="#1841B5"
    />
    <path
      d="M18.9375 21.9827H20.5977V20.4312H19.2478L13.5583 15.0008L19.2478 9.57035H20.5977V8.0188H18.9375C18.738 8.01918 18.5463 8.09642 18.4022 8.23447L11.8997 14.4407C11.8239 14.5131 11.7635 14.6001 11.7223 14.6965C11.6811 14.7929 11.6599 14.8967 11.6599 15.0015C11.6599 15.1064 11.6811 15.2101 11.7223 15.3065C11.7635 15.4029 11.8239 15.49 11.8997 15.5624L18.4022 21.7686C18.5465 21.9061 18.7382 21.9828 18.9375 21.9827Z"
      fill="white"
    />
    <path
      d="M15.1225 22.0013H16.9316V21.5358H15.2156L8.37175 15.0022L15.2156 8.47022H16.9316V8.00476H15.1225C15.0645 8.00622 15.0091 8.02947 14.9674 8.06991L7.87991 14.8347C7.85714 14.8562 7.83906 14.8822 7.82678 14.911C7.8145 14.9399 7.80829 14.9709 7.80854 15.0022C7.80826 15.0338 7.81445 15.0651 7.82672 15.0942C7.839 15.1233 7.8571 15.1495 7.87991 15.1713L14.9674 21.9361C15.0091 21.9765 15.0645 21.9998 15.1225 22.0013Z"
      fill="white"
    />
    <path
      d="M14.5913 21.9965H16.4004V21.531H14.6844L7.8405 14.9975L14.6844 8.46546H16.4004V8H14.5913C14.5332 8.00146 14.4778 8.02471 14.4361 8.06515L7.34866 14.8299C7.32589 14.8514 7.30781 14.8774 7.29553 14.9063C7.28325 14.9351 7.27704 14.9661 7.27729 14.9975C7.27701 15.029 7.2832 15.0603 7.29547 15.0894C7.30775 15.1185 7.32585 15.1448 7.34866 15.1666L14.4361 21.9313C14.4778 21.9718 14.5332 21.995 14.5913 21.9965Z"
      fill="white"
    />
    <path
      opacity="0.4"
      d="M6.6036 5.86366C7.39348 5.01024 8.70902 4.18583 9.41244 4.86107C10.1159 5.53632 9.48641 6.73983 8.69653 7.59326C7.90664 8.44669 6.49081 9.4988 5.68062 8.9048C4.87043 8.3108 5.81709 6.7129 6.6036 5.86366Z"
      fill="#F7FFF8"
    />
    <defs>
      <linearGradient
        id="paint0_linear_106_442"
        x1="2.90359"
        y1="29.9444"
        x2="2.90359"
        y2="0"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#29A3F8" />
        <stop offset="1" stopColor="#21D0FB" />
      </linearGradient>
    </defs>
  </SvgIcon>
);

export const KnightWithSwordIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 20 22">
    <g clipPath="url(#clip0_136_178)">
      <path
        d="M8.3291 9.7738C12.278 9.7738 16.1031 9.7738 19.9878 9.7738C19.9878 10.4228 20.0166 11.0547 19.9823 11.6835C19.8651 13.842 19.6627 15.9889 18.7703 18.0092C17.9586 19.8465 16.6615 21.1902 14.5881 21.6998C14.3382 21.7615 14.0352 21.7498 13.7886 21.6743C11.9507 21.1147 10.7608 19.8604 9.93476 18.2454C9.04568 16.507 8.67523 14.6368 8.49719 12.7271C8.40761 11.7622 8.38439 10.7909 8.3291 9.7738Z"
        fill="#FFFBF1"
      />
      <path
        d="M4.0042 0.373413C5.31571 5.47786 5.18412 10.5653 5.17748 15.7304C5.67511 15.6666 6.12186 15.624 6.56309 15.5495C6.99436 15.4761 7.4201 15.3697 7.89229 15.2687C7.89229 15.6878 7.89229 16.0825 7.89229 16.5581C7.04855 16.5581 6.19042 16.5581 5.3323 16.5581C4.4974 16.5581 4.43216 16.557 4.42331 17.4049C4.41004 18.673 4.4974 19.9412 4.54274 21.2093C4.54495 21.2753 4.55933 21.3412 4.57149 21.437C4.14907 21.437 3.75097 21.437 3.3208 21.437C3.39157 20.8125 3.51211 20.2072 3.51543 19.6007C3.52096 18.7209 3.44355 17.8411 3.39821 16.9613C3.38273 16.6591 3.23012 16.5432 2.90059 16.5506C1.94626 16.5698 0.990822 16.5581 0 16.5581C0 16.1208 0 15.7219 0 15.3229C0.859228 15.4825 1.71514 15.641 2.65177 15.8144C2.72144 10.6398 2.70928 5.52148 4.0042 0.373413Z"
        fill="#FFFBF1"
      />
      <path
        d="M12.7628 2.95976C11.1616 3.79489 9.59463 3.82575 8.02989 2.97465C7.8994 4.56407 7.64285 4.55982 9.66983 5.1375C9.66983 6.31095 9.66983 7.48333 9.66983 8.68019C8.6591 8.53657 7.79324 8.1323 7.01142 7.55781C6.91521 7.48759 6.86213 7.24077 6.91189 7.12694C7.54996 5.6822 7.54885 4.25023 6.91853 2.80124C6.84776 2.63847 6.91521 2.34378 7.03243 2.19164C7.7866 1.22352 8.74093 0.486258 9.92749 0.0617733C10.1287 -0.0105699 10.403 -0.0233363 10.5998 0.0468791C11.7775 0.469236 12.7872 1.13841 13.538 2.11504C13.684 2.30548 13.7691 2.6523 13.6962 2.86826C13.224 4.26406 13.1919 5.64816 13.7161 7.028C13.8377 7.34716 13.7614 7.53227 13.4761 7.67377C12.7374 8.03867 11.9976 8.39933 11.1859 8.79721C11.1859 7.46312 11.1859 6.30137 11.1859 5.09175C11.2114 5.08537 11.2777 5.07048 11.3429 5.05345C12.8181 4.65557 12.8988 4.5428 12.7628 2.95976Z"
        fill="#FFFBF1"
      />
    </g>
    <defs>
      <clipPath id="clip0_136_178">
        <rect width="20" height="21.7391" fill="white" />
      </clipPath>
    </defs>
  </SvgIcon>
);

export const OpenChestIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 57 62">
    <path
      opacity="0.2"
      d="M28.343 61.5002C42.8595 61.5002 54.6274 49.7323 54.6274 35.2158C54.6274 20.6993 42.8595 8.9314 28.343 8.9314C13.8265 8.9314 2.05859 20.6993 2.05859 35.2158C2.05859 49.7323 13.8265 61.5002 28.343 61.5002Z"
      fill="black"
    />
    <path
      opacity="0.2"
      d="M28.343 57.195C42.8595 57.195 54.6274 45.4271 54.6274 30.9106C54.6274 16.3941 42.8595 4.62616 28.343 4.62616C13.8265 4.62616 2.05859 16.3941 2.05859 30.9106C2.05859 45.4271 13.8265 57.195 28.343 57.195Z"
      fill="black"
    />
    <path
      d="M2.05924 30.3558C2.05924 44.8705 13.908 58.378 28.3437 58.378C42.7793 58.378 54.5688 44.8705 54.5688 30.3558C54.5688 23.3848 51.7996 16.6992 46.8703 11.7699C41.941 6.84065 35.2555 4.07141 28.2844 4.07141C21.3134 4.07141 14.6278 6.84065 9.69852 11.7699C4.76924 16.6992 2 23.3848 2 30.3558H2.05924Z"
      fill="#014549"
      fillOpacity="0.97"
    />
    <path
      d="M28.3443 54.3522C42.7299 54.3522 54.3918 42.6904 54.3918 28.3048C54.3918 13.9192 42.7299 2.25732 28.3443 2.25732C13.9587 2.25732 2.29688 13.9192 2.29688 28.3048C2.29688 42.6904 13.9587 54.3522 28.3443 54.3522Z"
      fill="url(#paint0_linear_103_259)"
    />
    <path
      d="M28.3436 2.493C33.4493 2.493 38.4403 4.00726 42.6852 6.84422C46.9301 9.68119 50.2383 13.7134 52.1913 18.4308C54.1442 23.1482 54.6542 28.3388 53.6567 33.3461C52.6592 38.3534 50.199 42.9523 46.5874 46.5612C42.9758 50.1701 38.375 52.6267 33.3669 53.6204C28.3589 54.6141 23.1686 54.1001 18.4527 52.1436C13.7368 50.187 9.70715 46.8757 6.87344 42.6286C4.03972 38.3815 2.52926 33.3894 2.53316 28.2837C2.54362 21.4434 5.26691 14.8865 10.1056 10.0515C14.9443 5.2165 21.5033 2.49822 28.3436 2.493ZM28.3436 2.01905C23.1417 2.00733 18.0533 3.53941 13.7226 6.42131C9.39197 9.30322 6.01385 13.4053 4.01594 18.2083C2.01803 23.0113 1.4902 28.299 2.49929 33.4022C3.50838 38.5053 6.00898 43.1942 9.68453 46.8753C13.3601 50.5564 18.0453 53.0641 23.1469 54.0808C28.2485 55.0976 33.537 54.5777 38.343 52.5871C43.1489 50.5964 47.2561 47.2244 50.1445 42.8981C53.0329 38.5718 54.5727 33.4856 54.5688 28.2837C54.5688 24.8329 53.8888 21.416 52.5676 18.2281C51.2465 15.0402 49.3101 12.144 46.8691 9.70481C44.4281 7.26565 41.5303 5.33142 38.3415 4.01266C35.1526 2.69389 31.7352 2.01645 28.2844 2.01905H28.3436Z"
      fill="#00FDEE"
      stroke="#33CA93"
      strokeWidth="3"
    />
    <g style={{ mixBlendMode: "overlay" }} opacity="0.28">
      <path
        d="M2.05859 28.2844C2.05859 28.2844 13.9073 12.6638 28.343 12.6638C42.7787 12.6638 54.2917 28.2844 54.6274 28.2844C54.6274 21.3134 51.8582 14.6278 46.9289 9.69853C41.9996 4.76924 35.3141 2 28.343 2C21.3719 2 14.6864 4.76924 9.75712 9.69853C4.82783 14.6278 2.05859 21.3134 2.05859 28.2844Z"
        fill="white"
      />
    </g>
    <path
      d="M11.6936 19.495C12.9648 17.8957 13.3747 16.1059 12.6091 15.4973C11.8434 14.8887 10.1922 15.6919 8.92096 17.2912C7.6497 18.8905 7.23981 20.6804 8.00544 21.2889C8.77107 21.8975 10.4223 21.0944 11.6936 19.495Z"
      fill="white"
      fillOpacity="0.5"
    />
    <path
      d="M16.0929 11.3149C16.3989 10.9312 16.3152 10.3555 15.9059 10.0291C15.4966 9.70273 14.9167 9.74923 14.6107 10.1329C14.3047 10.5167 14.3884 11.0924 14.7978 11.4187C15.2071 11.7451 15.7869 11.6986 16.0929 11.3149Z"
      fill="white"
      fillOpacity="0.5"
    />
    <path
      d="M30.0231 40.2101C27.1641 40.1202 24.3898 40.0329 21.5684 39.9439C21.0788 36.3231 20.5909 32.7197 20.0996 29.0875C20.9915 29.0875 21.8441 29.0875 22.7866 29.0875C22.7866 30.1775 22.7866 31.2588 22.7866 32.4116C24.2554 32.4116 25.6351 32.4116 27.0838 32.4116C27.0838 31.3513 27.0838 30.2805 27.0838 29.1844C27.9696 29.1844 28.7891 29.1844 29.6399 29.1844C29.7674 32.8619 29.8948 36.5159 30.0231 40.2101Z"
      fill="#FFFBF1"
    />
    <path
      d="M29.651 28.378C28.7853 28.378 27.9772 28.378 27.1472 28.378C27.1359 28.1659 27.1272 27.9949 27.1149 27.7566C25.675 27.7566 24.2342 27.7566 22.7724 27.7566C22.7654 27.9032 22.7576 28.0743 22.7471 28.2811C21.8683 28.2811 20.9938 28.2811 20.0723 28.2811C20.2869 26.0741 20.5714 23.929 21.7156 22.0073C22.1091 21.3467 22.6144 20.9775 23.4793 21.0011C26.0494 21.0709 28.623 21.0395 31.1948 21.0482C31.3929 21.0491 31.5919 21.0482 31.8546 21.0482C30.3003 23.2928 29.9137 25.8192 29.651 28.378Z"
      fill="#FFFBF1"
    />
    <path
      d="M34.1699 40.1908C34.313 36.4932 34.4544 32.8549 34.5967 29.1765C36.3508 28.8143 38.104 28.4512 39.9323 28.0734C39.873 28.4486 39.818 28.768 39.7709 29.0883C39.4838 31.0554 39.1984 33.0224 38.9122 34.9895C38.735 36.2095 38.5605 37.4296 38.372 38.647C38.3554 38.7526 38.2611 38.9018 38.1704 38.9315C36.8648 39.353 35.554 39.7579 34.1699 40.1908Z"
      fill="#FFFBF1"
    />
    <path
      d="M30.8895 40.2684C30.7699 36.5568 30.6538 32.9317 30.5352 29.262C31.6409 29.262 32.7047 29.262 33.8174 29.262C33.6812 32.9378 33.5451 36.6014 33.409 40.2684C32.572 40.2684 31.7543 40.2684 30.8895 40.2684Z"
      fill="#FFFBF1"
    />
    <path
      d="M16.129 29.0421C17.1047 29.0421 18.0324 29.0316 18.9601 29.056C19.0656 29.0587 19.2411 29.2437 19.2585 29.3624C19.5064 31.072 19.7333 32.7851 19.9645 34.4973C20.1958 36.2087 20.4262 37.92 20.6557 39.6323C20.6653 39.703 20.6627 39.7754 20.6653 39.826C19.9052 39.826 19.1538 39.8374 18.4033 39.8103C18.316 39.8068 18.186 39.6043 18.1607 39.4769C17.8011 37.7158 17.4546 35.9521 17.1073 34.1884C16.7792 32.5259 16.4545 30.8625 16.1299 29.1992C16.1194 29.1442 16.129 29.0848 16.129 29.0421Z"
      fill="#FFFBF1"
    />
    <path
      d="M40 27.2827C38.1883 27.6571 36.4472 28.0166 34.6172 28.3936C34.6844 27.7862 34.7341 27.219 34.8127 26.6552C34.9977 25.3174 35.2665 23.9978 35.8547 22.7708C36.0528 22.3572 36.2989 21.9496 36.5956 21.6023C37.1087 21.0027 37.6804 21.0088 38.2459 21.5578C38.3698 21.6782 38.4832 21.8143 38.5784 21.9592C39.6361 23.5693 39.9057 25.3846 40 27.2827Z"
      fill="#FFFBF1"
    />
    <path
      d="M33.8438 28.4365C32.7267 28.4365 31.6559 28.4365 30.4961 28.4365C30.6287 27.5306 30.7308 26.6579 30.8897 25.7957C31.1209 24.5364 31.491 23.319 32.1472 22.2054C32.2354 22.0562 32.3392 21.9157 32.4361 21.7708C32.7538 21.2926 33.1447 21.0308 33.7731 21.0901C34.4747 21.1564 35.1868 21.1049 35.9662 21.1049C34.3848 23.3417 34.1143 25.8795 33.8438 28.4365Z"
      fill="#FFFBF1"
    />
    <path
      d="M19.1941 28.2287C18.1259 28.2287 17.0865 28.2287 16 28.2287C16.0707 26.0286 16.3159 23.9315 17.5377 22.0805C17.9391 21.4714 18.4802 21.083 19.2683 21.0961C19.9271 21.1066 20.5869 21.0446 21.3252 21.0115C19.7971 23.2499 19.4568 25.7415 19.1941 28.2287Z"
      fill="#FFFBF1"
    />
    <path
      d="M23.2676 31.9683C23.2676 30.64 23.2676 29.4086 23.2676 28.1703C24.3663 28.1703 25.4947 28.1703 26.6257 28.1703C26.6257 29.4628 26.6257 30.7151 26.6257 31.9683C25.4912 31.9683 24.4265 31.9683 23.2676 31.9683ZM24.3314 31.2762C24.7346 31.2762 25.0976 31.2762 25.513 31.2762C25.4441 30.9655 25.3559 30.702 25.3359 30.4341C25.3219 30.2534 25.3612 30.0422 25.4485 29.8843C25.6352 29.5465 25.6457 29.2437 25.3586 28.9784C25.102 28.741 24.8053 28.7402 24.5225 28.9391C24.2433 29.1364 24.1359 29.557 24.3715 29.8258C24.5941 30.0798 24.5478 30.3197 24.5077 30.5798C24.4745 30.7936 24.403 31.0004 24.3314 31.2762Z"
      fill="#FFFBF1"
    />
    <defs>
      <linearGradient
        id="paint0_linear_103_259"
        x1="28.0005"
        y1="-0.500488"
        x2="30.5005"
        y2="49.4995"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#3DFFB9" />
        <stop offset="1" stopColor="#07866F" />
      </linearGradient>
    </defs>
  </SvgIcon>
);

export const CloseIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 30 31">
    <circle cx="14" cy="14" r="14" transform="matrix(-1 0 0 1 29 2.4021)" fill="#1841B5" stroke="#1841B5" />
    <circle
      cx="14"
      cy="14"
      r="14"
      transform="matrix(-1 0 0 1 29 1)"
      fill="url(#paint0_linear_104_974)"
      stroke="#1841B5"
    />
    <path
      d="M20.8497 22.1431H22.4121V20.6829H21.1417L15.787 15.572L21.1417 10.4612H22.4121V9.00098H20.8497C20.6619 9.00133 20.4815 9.07403 20.3459 9.20395L14.226 15.0449C14.1547 15.1131 14.0979 15.195 14.0591 15.2857C14.0203 15.3764 14.0003 15.4741 14.0003 15.5728C14.0003 15.6714 14.0203 15.7691 14.0591 15.8598C14.0979 15.9505 14.1547 16.0325 14.226 16.1006L20.3459 21.9416C20.4817 22.071 20.6621 22.1431 20.8497 22.1431Z"
      fill="white"
    />
    <path
      d="M9.56245 9.00046H8V10.4607H9.27041L14.6251 15.5715L9.27041 20.6823H8V22.1426H9.56245C9.75023 22.1422 9.93066 22.0695 10.0662 21.9396L16.1861 16.0987C16.2574 16.0305 16.3142 15.9486 16.353 15.8578C16.3918 15.7671 16.4118 15.6695 16.4118 15.5708C16.4118 15.4721 16.3918 15.3745 16.353 15.2837C16.3142 15.193 16.2574 15.1111 16.1861 15.0429L10.0662 9.20198C9.93043 9.07259 9.75003 9.00043 9.56245 9.00046Z"
      fill="white"
    />
    <path
      opacity="0.4"
      d="M6.63485 5.36366C7.42473 4.51024 8.74027 3.68583 9.44369 4.36107C10.1471 5.03632 9.51766 6.23983 8.72778 7.09326C7.93789 7.94669 6.52206 8.9988 5.71187 8.4048C4.90168 7.8108 5.84834 6.2129 6.63485 5.36366Z"
      fill="#F7FFF8"
    />
    <defs>
      <linearGradient
        id="paint0_linear_104_974"
        x1="2.90359"
        y1="29.9444"
        x2="2.90359"
        y2="0"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#29A3F8" />
        <stop offset="1" stopColor="#21D0FB" />
      </linearGradient>
    </defs>
  </SvgIcon>
);

export const QuestionIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 35 35" fill="none">
    <circle cx="17.5" cy="17.5" r="17.5" fill="#1A98F4" />
    <circle cx="17.5513" cy="17.5005" r="13.7203" fill="url(#paint0_linear_2501_16)" />
    <path
      d="M17.6865 7.56445C19.235 7.66977 20.6716 7.9989 21.9331 8.89412C24.5469 10.7478 24.7931 14.122 22.4809 16.3324C21.8778 16.909 21.2734 17.4856 20.6348 18.0201C19.6617 18.8351 18.948 19.7829 18.7597 21.081C18.6596 21.7735 18.258 22.2356 17.5114 22.3172C16.4356 22.4344 15.7298 21.8551 15.6627 20.769C15.5758 19.3564 16.0195 18.1255 17.0281 17.1289C17.7932 16.3732 18.5938 15.6544 19.3851 14.9277C20.1936 14.1852 20.7203 13.3347 20.3648 12.1933C20.0435 11.1638 19.268 10.6043 18.2422 10.4713C17.0913 10.3225 15.9629 10.445 15.2768 11.5574C14.9121 12.1485 14.6474 12.8055 14.3815 13.4505C13.9588 14.4748 13.2727 14.9185 12.3642 14.7025C11.4029 14.4735 10.8854 13.6967 11.0764 12.5948C11.4806 10.2593 12.9909 8.85595 15.1294 8.09501C15.9405 7.80537 16.8319 7.73428 17.6865 7.56445Z"
      fill="#1A98F4"
    />
    <path
      d="M17.3819 27.4356C16.2416 27.4369 15.4252 26.6365 15.4199 25.5135C15.4147 24.4037 16.2456 23.5651 17.3609 23.5519C18.4696 23.5387 19.3255 24.3813 19.3294 25.4885C19.3334 26.6102 18.5091 27.4356 17.3819 27.4356Z"
      fill="#1A98F4"
    />
    <defs>
      <linearGradient
        id="paint0_linear_2501_16"
        x1="1.88273"
        y1="-1.22392"
        x2="31.2715"
        y2="36.434"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F0FBFF" />
        <stop offset="1" stopColor="#C4E7F5" />
      </linearGradient>
    </defs>
  </SvgIcon>
);

export const KnightIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 23 17" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22.8398 5.23942C22.2227 5.74276 21.5324 6.14433 20.794 6.4296C22.1647 5.20542 22.8398 3.68041 22.4205 1.66887C22.0445 2.68903 21.326 3.49992 20.523 4.26897C21.0054 3.49244 21.181 2.55725 21.014 1.65318C20.4437 2.96107 19.0628 3.90014 18.201 5.44868C17.8262 5.44785 17.4576 5.35194 17.1279 5.16955C16.7983 4.98717 16.5181 4.724 16.3123 4.40362C16.1066 4.08324 15.9817 3.71566 15.9489 3.3338C15.9161 2.95194 15.9765 2.56772 16.1245 2.21557C15.7972 2.09001 15.4622 1.96707 15.117 1.84936C14.5544 1.65841 14.0046 1.491 13.4726 1.35236C13.3294 1.31312 13.1913 1.28174 13.0507 1.24773L11.9409 0L11.9153 0.0287738L10.8157 1.26343C10.1636 1.4256 9.48078 1.62179 8.76987 1.85982C8.42464 1.97754 8.08964 2.10048 7.76231 2.22603L7.72907 2.23911C7.88252 2.58985 7.94569 2.97493 7.91257 3.3577C7.87945 3.74046 7.75113 4.10819 7.53983 4.42591C7.38663 4.66674 7.19162 4.87686 6.96445 5.04586C6.58882 5.3113 6.14237 5.45195 5.68583 5.44868V5.46699H5.65514V5.62394C4.80869 3.87921 3.27434 2.89829 2.66572 1.51192C2.49688 2.416 2.67255 3.35188 3.15671 4.12771C2.35373 3.3639 1.62236 2.55824 1.25923 1.52762C0.832172 3.53916 1.51496 5.06678 2.88564 6.28835C2.14698 6.00367 1.45663 5.60204 0.839844 5.09817C1.30271 7.08617 2.53274 7.87614 4.04663 8.46207C3.24492 8.35396 2.47363 8.07792 1.78091 7.65118C2.82171 9.61302 3.80369 9.82228 5.37896 10.0629L5.57075 10.0839C4.91233 10.1535 4.24708 10.1066 3.60423 9.94522C3.8951 10.3096 4.26682 10.5978 4.68847 10.7857C5.11012 10.9736 5.56952 11.0558 6.0285 11.0255C6.04896 11.0935 6.06686 11.1616 6.08987 11.2296L5.6219 12.7232L6.91842 13.0135C8.11777 14.91 9.95132 15.9668 11.455 16.762L11.9051 17L12.3551 16.762C12.8666 16.5004 13.3985 16.1996 13.9381 15.8543L14.1299 15.7313H14.1452C15.2466 15.0401 16.1902 14.1151 16.9121 13.0188C17.0707 12.9874 18.1908 12.7363 18.1908 12.7363H18.2266L17.7586 11.24C17.7586 11.24 17.7586 11.2139 17.7586 11.2034C18.1975 11.2123 18.6327 11.1192 19.0313 10.9312C19.43 10.7431 19.7817 10.4651 20.0601 10.1179C19.4172 10.2792 18.752 10.3261 18.0936 10.2565C18.1575 10.2565 18.224 10.2434 18.2854 10.233C19.8607 9.99492 20.8426 9.78566 21.8834 7.82382C21.19 8.24856 20.419 8.52363 19.6177 8.6321C21.1469 8.01739 22.377 7.22742 22.8398 5.23942Z"
      fill="white"
    />
  </SvgIcon>
);

export const SwordIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 18 18" fill="none">
    <g clipPath="url(#clip0_558_2032)">
      <path
        d="M0 16.3152C0.270868 15.7583 0.651775 15.3586 1.32894 15.3572C1.40371 15.3572 1.49683 15.2804 1.55043 15.2141C2.25441 14.3323 2.95203 13.4455 3.68281 12.5206C3.04655 11.9017 2.41947 11.2913 1.7952 10.6843C2.1098 10.3728 2.40607 10.0788 2.72278 9.76514C3.62144 10.3939 4.52081 11.058 5.45756 11.6656C5.98166 12.0054 6.28568 12.5044 6.62779 12.9852C7.16812 13.7451 7.7028 14.5092 8.22619 15.2529C7.91018 15.5574 7.60404 15.8528 7.28027 16.1644C6.71314 15.5821 6.10298 14.9554 5.48366 14.3196C4.55819 15.0499 3.67082 15.7477 2.78838 16.4505C2.72208 16.5034 2.64519 16.5972 2.64519 16.6719C2.64378 17.3486 2.24383 17.7293 1.68657 18C1.42911 18 1.17164 18 0.913473 18C0.507877 17.7969 0.203151 17.4931 0 17.0871C0 16.8298 0 16.5725 0 16.3152Z"
        fill="white"
      />
      <path
        d="M7.16306 12.8005C6.7617 11.8813 6.10146 11.2476 5.20703 10.8303C6.1459 9.80254 7.04315 8.82201 7.93828 7.84006C9.46262 6.16659 10.9855 4.49101 12.5099 2.81754C12.895 2.3946 13.2795 1.97165 13.6709 1.55504C13.7478 1.47327 13.8473 1.39503 13.9517 1.35978C15.2764 0.90934 16.6039 0.467358 17.9999 0C17.9519 0.16636 17.9223 0.281966 17.8849 0.394752C17.5421 1.42322 17.1774 2.44535 16.8635 3.48228C16.7119 3.98347 16.4494 4.36695 16.0643 4.71447C13.6653 6.88138 11.2811 9.0645 8.89055 11.2406C8.33964 11.7432 7.7838 12.2408 7.16306 12.8005Z"
        fill="white"
      />
      <g clipPath="url(#clip1_558_2032)">
        <path
          d="M18 16.3152C17.7291 15.7583 17.3482 15.3586 16.6711 15.3572C16.5963 15.3572 16.5032 15.2804 16.4496 15.2141C15.7456 14.3323 15.048 13.4455 14.3172 12.5206C14.9534 11.9017 15.5805 11.2913 16.2048 10.6843C15.8902 10.3728 15.5939 10.0788 15.2772 9.76514C14.3786 10.3939 13.4792 11.058 12.5424 11.6656C12.0183 12.0054 11.7143 12.5044 11.3722 12.9852C10.8319 13.7451 10.2972 14.5092 9.77381 15.2529C10.0898 15.5574 10.396 15.8528 10.7197 16.1644C11.2869 15.5821 11.897 14.9554 12.5163 14.3196C13.4418 15.0499 14.3292 15.7477 15.2116 16.4505C15.2779 16.5034 15.3548 16.5972 15.3548 16.6719C15.3562 17.3486 15.7562 17.7293 16.3134 18C16.5709 18 16.8284 18 17.0865 18C17.4921 17.7969 17.7968 17.4931 18 17.0871C18 16.8298 18 16.5725 18 16.3152Z"
          fill="white"
        />
        <path
          d="M10.8369 12.8005C11.2383 11.8813 11.8985 11.2476 12.793 10.8303C11.8541 9.80254 10.9569 8.82201 10.0617 7.84006C8.53738 6.16659 7.01446 4.49101 5.49012 2.81754C5.10498 2.3946 4.72055 1.97165 4.32906 1.55504C4.25217 1.47327 4.15271 1.39503 4.04832 1.35978C2.72361 0.90934 1.39607 0.467359 0.000117161 0C0.0480833 0.16636 0.0777076 0.281966 0.115093 0.394752C0.45791 1.42322 0.822594 2.44535 1.13649 3.48228C1.28815 3.98347 1.55055 4.36695 1.93569 4.71447C4.3347 6.88138 6.7189 9.0645 9.10945 11.2406C9.66036 11.7432 10.2162 12.2408 10.8369 12.8005Z"
          fill="white"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_558_2032">
        <rect width="18" height="18" fill="white" />
      </clipPath>
      <clipPath id="clip1_558_2032">
        <rect width="18" height="18" fill="white" transform="matrix(-1 0 0 1 18 0)" />
      </clipPath>
    </defs>
  </SvgIcon>
);

export const HelmetFullIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 20 22" fill="none">
    <path d="M15.6543 7.7283C11.9316 9.62702 8.28869 9.69716 4.65089 7.76216C4.34752 11.3758 3.75108 11.3661 8.46352 12.6795C8.46352 15.3474 8.46352 18.0128 8.46352 20.7339C6.11372 20.4074 4.10072 19.4883 2.2831 18.1822C2.05943 18.0225 1.93603 17.4614 2.05172 17.2026C3.53512 13.9179 3.53255 10.6622 2.06714 7.3679C1.90261 6.99783 2.05943 6.32784 2.33194 5.98196C4.08529 3.78089 6.30397 2.10469 9.06253 1.13961C9.53043 0.975136 10.168 0.946111 10.6256 1.10575C13.3636 2.06599 15.7108 3.58739 17.4565 5.80781C17.7958 6.24076 17.9938 7.02928 17.8241 7.52028C16.7264 10.6937 16.6518 13.8405 17.8704 16.9776C18.1532 17.7032 17.9758 18.1241 17.3125 18.4458C15.5952 19.2754 13.8752 20.0954 11.9882 21C11.9882 17.9669 11.9882 15.3256 11.9882 12.5755C12.0473 12.561 12.2016 12.5271 12.3533 12.4884C15.7828 11.5838 15.9705 11.3274 15.6543 7.7283Z" />
  </SvgIcon>
);

export const ArrowCssIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 20 14" fill="none">
    <path
      d="M11.5693 13.0137C10.7686 14.0272 9.23143 14.0272 8.43068 13.0137L1.30134 3.98985C0.265226 2.67841 1.19931 0.75 2.87066 0.75L17.1293 0.750001C18.8007 0.750002 19.7348 2.67841 18.6987 3.98986L11.5693 13.0137Z"
      fill="#2F5281"
    />
  </SvgIcon>
);

export const HelmetWingIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 24 23" fill="none">
    <path d="M5.28588 9.09363V10.0589L6 10.4768V14L1.21876 11.2008C1.06533 11.111 0.937915 10.9818 0.849332 10.8263C0.760748 10.6707 0.714114 10.4943 0.714116 10.3147V9.93871L0.504642 9.81612C0.351242 9.72628 0.223857 9.59711 0.135278 9.44157C0.0467 9.28604 4.62532e-05 9.10962 0 8.93002V6L5.28588 9.09363Z" />
    <path d="M5.28588 7.09363V8.05888L6 8.47683V12L1.21876 9.20077C1.06533 9.11097 0.937915 8.98181 0.849332 8.82626C0.760748 8.67072 0.714114 8.49428 0.714116 8.31467V7.93871L0.504642 7.81612C0.351242 7.72628 0.223857 7.59711 0.135278 7.44157C0.0467 7.28604 4.62532e-05 7.10962 0 6.93002V4L5.28588 7.09363Z" />
    <path d="M18.7141 9.09363V10.0589L18 10.4768V14L22.7812 11.2008C22.9347 11.111 23.0621 10.9818 23.1507 10.8263C23.2393 10.6707 23.2859 10.4943 23.2859 10.3147V9.93871L23.4954 9.81612C23.6488 9.72628 23.7761 9.59711 23.8647 9.44157C23.9533 9.28604 24 9.10962 24 8.93002V6L18.7141 9.09363Z" />
    <path d="M18.7141 7.09363V8.05888L18 8.47683V12L22.7812 9.20077C22.9347 9.11097 23.0621 8.98181 23.1507 8.82626C23.2393 8.67072 23.2859 8.49428 23.2859 8.31467V7.93871L23.4954 7.81612C23.6488 7.72628 23.7761 7.59711 23.8647 7.44157C23.9533 7.28604 24 7.10962 24 6.93002V4L18.7141 7.09363Z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.65089 9.76194C10.2887 11.6969 13.9316 11.6268 17.6543 9.72808C17.9705 13.3272 17.7828 13.5836 14.3533 14.4882C14.251 14.5143 14.1475 14.5382 14.0729 14.5554C14.0368 14.5638 14.0075 14.5705 13.9882 14.5753V21.8647L15.2107 21.1666V18.3721L15.6907 18.0983V20.8913L16.8058 20.2543V17.4614L18.097 16.7248C18.4805 16.5052 18.8127 16.2138 19.077 15.8701C18.8122 13.7619 19.0884 11.647 19.8241 9.52006C19.9938 9.02906 19.7958 8.24054 19.4565 7.80759C18.6367 6.7648 17.6842 5.87619 16.6208 5.12747L14.1525 3.71916C13.6588 3.49344 13.1494 3.28922 12.6256 3.10553C12.4285 3.03676 12.1979 3.003 11.9619 3C11.7031 3.00296 11.4465 3.03575 11.1972 3.09705C11.1511 3.10996 11.1061 3.12409 11.0625 3.13939C10.8875 3.20062 10.7147 3.2647 10.544 3.3316C10.4751 3.36478 10.4072 3.40037 10.3405 3.43834L6.96529 5.36407C5.99033 6.12095 5.11476 6.99903 4.33194 7.98174C4.05943 8.32762 3.90261 8.99761 4.06714 9.36768C5.05532 11.5892 5.3783 13.7931 5.02899 16.0002C5.27419 16.2875 5.56916 16.5333 5.90302 16.7248L7.19497 17.463V20.2559L8.31013 20.8928V18.0999L8.79012 18.3737V21.1666L10.4635 22.1222V14.6793C6.26797 13.5099 6.28055 13.3894 6.54788 10.8268C6.58081 10.5111 6.61761 10.1583 6.65089 9.76194Z"
    />
    <rect x="9" y="2.82861" width="4" height="4" transform="rotate(-45 9 2.82861)" />
  </SvgIcon>
);
